import { Box, Breadcrumbs, Button, Card, CardActionArea, CardActions, CardContent, CardMedia, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import HomeIcon from '@material-ui/icons/Home';
import { Alert, AlertTitle } from '@material-ui/lab';
import axios from 'axios';
import { Form, Formik, FormikProps } from 'formik';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { pdfjs } from 'react-pdf';
import { Link, useHistory } from 'react-router-dom';
import { AppInput } from '../components/atoms/inputs/AppInput';
import { LoadingButton } from '../components/atoms/inputs/LodingButton';
import { PdfViewer } from '../components/atoms/inputs/PdfViewer';
import { AppShell } from '../components/molecules/app-shell/AppShell';
import { useStore } from '../store';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;



const useStyles = makeStyles((theme) => ({
    controlPaper: {
        width: "100%",
        padding: "8px",
    },
    link: {
        display: 'flex',
        textDecoration: 'none',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    datePicker: {
        marginTop: 30,
        marginBottom: 30
    },
    relation: {
        marginBottom: 30
    },
    signature: {
        maxWidth: 345,
    },

}))

type FormikForm = {
    year: string,
    part: string,
    file: any,
    fileName?: string,

    nameOfPensioner: string,
    ppoNo: string,
    guardianName: string,
    maritialStat: string,
    maritalStatusOthers: string,
    relationWith: string,
    address: string,
    sex: string,
    contactNo: string,
    dateOfBirth: string,
    dateOfCommencement: string,
    panNum: string,
    aadharNum: string,

    spouseName: string,
    postAtRetirement: string,
    dateOfSuperAnnuation: string
}

type AplicationFormPensionerIdentityCardPageProps = {
}

type PPONumApiData = {
    'nameOfPensioner': string,
    'guardianName': string,
    'maritialStat': string,
    'relationWith': string,
    'address': string,
    'sex': string,
    'contactNo': string,
    'dateOfBirth': string,
    'dateOfCommencement': string,
    'panNum': string,
    'aadharNum': string,
    'ppoNo': string,

    "spouseName": string,
    "postAtRetirement": string,
    "dateOfSuperAnnuation": string
}

type PPONumSubmitApiData = {
    pdfUrl: string,
    Success: string
}

export const AplicationFormPensionerIdentityCardPage: FunctionComponent<AplicationFormPensionerIdentityCardPageProps> = () => {
    const classes = useStyles()
    const store = useStore()
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();

    const getFiscalYear = (y: number) => `${y}-${(y + 1).toString().slice(-2)}`;

    const [profilePicture, setProfilePicture] = useState('');
    const [profilePictureBase64, setProfilePictureBase64] = useState('');
    const [profilePictureImageType, setProfilePictureImageType] = useState('');
    const [alreadySubmittedForm, setAlreadySubmittedForm] = useState<any>(null);
    const [alreadySubmittedFormName, setAlreadySubmittedFormName] = useState('');
    const [user, setUser] = useState<any>({
        nameOfPensioner: "",
        ppoNo: "",
        guardianName: "",
        maritialStat: "U",
        relationWith: "",
        address: "",
        sex: "",
        contactNo: "",
        dateOfBirth: "",
        dateOfCommencement: "",
        panNum: "",
        aadharNum: "",

        spouseName: "",
        postAtRetirement: "",
        dateOfSuperAnnuation: ""
    });

    const [signPicture, setSignPicture] = useState('');
    const [signPictureBase64, setSignPictureBase64] = useState('');
    const [signPictureImageType, setSignPictureImageType] = useState('');

    const [userMaritalStat, setUserMaritalStat] = useState('');

    // useEffect(() => {
    //   console.log(profilePictureBase64, "+++++++");
    // }, [profilePictureBase64])


    const handleProfilePicChange = (e: (React.ChangeEvent<HTMLInputElement>) | any) => {
        console.log(e.target.files[0]);

        if (e.target.files[0] && e.target.files[0].size > 245760) {
            // alert("The image must be less than or equal to 240 kB (kilobytes)");
            enqueueSnackbar("The image must be less than or equal to 240 kB (kilobytes)", { variant: 'error' });

            setProfilePicture('');
            setProfilePictureImageType('');
            setProfilePictureBase64('');
            return;
        }

        toBase64(e.target.files[0]).then((result: any) => {
            // console.log(result, "original base64");
            setProfilePicture(URL.createObjectURL(e.target?.files[0]));
            setProfilePictureImageType(e.target.files[0].name.substring(e.target.files[0].name.lastIndexOf(".") + 1, e.target.files[0].name.length));

            let remainder = result.substring(result.indexOf(",") + 1, result.length);
            setProfilePictureBase64(remainder);
        })
            .catch((e) => {
                setProfilePicture('');
                setProfilePictureImageType('');
                setProfilePictureBase64('');
                console.log(e, "prof error");
            });
    }

    const handleSignPicChange = (e: (React.ChangeEvent<HTMLInputElement>) | any) => {
        console.log(e.target.files[0]);

        if (e.target.files[0] && e.target.files[0].size > 102400) {
            // alert("The image must be less than or equal to 240 kB (kilobytes)");
            enqueueSnackbar("The image must be less than or equal to 100 kB (kilobytes)", { variant: 'error' });

            setSignPicture('');
            setSignPictureImageType('');
            setSignPictureBase64('');
            return;
        }

        toSignatureBase64(e.target.files[0]).then((result: any) => {
            // console.log(result, "original base64");
            setSignPicture(URL.createObjectURL(e.target?.files[0]));
            setSignPictureImageType(e.target.files[0].name.substring(e.target.files[0].name.lastIndexOf(".") + 1, e.target.files[0].name.length));

            let remainder = result.substring(result.indexOf(",") + 1, result.length);
            setSignPictureBase64(remainder);
        })
            .catch((e) => {
                setSignPicture('');
                setSignPictureImageType('');
                setSignPictureBase64('');
                console.log(e, "prof error");
            });
    }

    useEffect(() => {
        fetchPensionersDetails()
    }, []);

    const getMaritalStatus = (maritialStat: any) => {
        if (maritialStat == '0') {
            return 'Single'
        }
        else if (maritialStat == 'M' || maritialStat == '1') {
            return 'Married'
        }
        else if (maritialStat == 'U') {
            return 'Unmarried'
        }
        else if (maritialStat == 'W' || maritialStat == '2') {
            return 'Widow'
        }
        else if (maritialStat == 'D' || maritialStat == '3') {
            return 'Divorcee'
        }
        else if (maritialStat == 'P') {
            return 'Physically Challanged'
        }
        else if (maritialStat == '4') {
            return 'NM'
        }
        else if (maritialStat == '5') {
            return 'Sep.'
        }
        else if (maritialStat == '6') {
            return 'Unknown'
        }
        else if (maritialStat == '9') {
            return 'RegCou'
        }
        else if (maritialStat == 'A') {
            return 'RegcRP'
        }
        else {
            return maritialStat
        }
    }

    const getMaritalStatusForDropdown = (maritialStat: any) => {
        if (maritialStat == '0') {
            return 'U'
        }
        else if (maritialStat == 'M' || maritialStat == '1') {
            return 'O'
        }
        else if (maritialStat == 'U') {
            return 'U'
        }
        else if (maritialStat == 'W' || maritialStat == '2') {
            return 'W'
        }
        else if (maritialStat == 'D' || maritialStat == '3') {
            return 'D'
        }
        else if (maritialStat == 'P') {
            return 'O'
        }
        else if (maritialStat == '4') {
            return 'O'
        }
        else if (maritialStat == '5') {
            return 'O'
        }
        else if (maritialStat == '6') {
            return 'O'
        }
        else if (maritialStat == '9') {
            return 'O'
        }
        else if (maritialStat == 'A') {
            return 'O'
        }
        else if (maritialStat == 'R') {
            return 'R'
        }
        else if (maritialStat == 'NA' || maritialStat == '') {
            return 'NA'
        }
        else {
            return maritialStat
        }
    }

    const getMaritalStatusToUpdate = (maritialStat: any) => {
        if (maritialStat == 'U' && user.ppoNo.startsWith("800")) {
            return '0'
        }
        else if (maritialStat == 'U' && !user.ppoNo.startsWith("800")) {
            return 'U'
        }
        else if (maritialStat == 'W' && user.ppoNo.startsWith("800")) {
            return '2'
        }
        else if (maritialStat == 'W' && !user.ppoNo.startsWith("800")) {
            return 'W'
        }
        else if (maritialStat == 'D' && user.ppoNo.startsWith("800")) {
            return '3'
        }
        else if (maritialStat == 'D' && !user.ppoNo.startsWith("800")) {
            return 'D'
        }
        else if (maritialStat == 'R') {
            return 'R'
        }
        else if (maritialStat == 'O') {
            return 'O'
        }
        else {
            return 'O'
        }
    }

    const getSex = (sex: any) => {
        if (sex == 'M' || sex == '1') {
            return 'Male'
        }
        else if (sex == 'F' || sex == '2') {
            return 'Female'
        }
        else {
            return sex
        }
    }

    const getRelationWith = (relationWith: any) => {
        if (relationWith == 'S') {
            return 'Son'
        }
        else if (relationWith == 'D') {
            return 'Daughter'
        }
        else if (relationWith == 'W') {
            return 'Spouse'
        }
        else if (relationWith == 'F') {
            return 'Father'
        }
        else if (relationWith == 'M') {
            return 'Mother'
        }
        else {
            return relationWith
        }
    }

    const fetchPensionersDetails = async () => {
        console.log("KKKKKKKKKKKKKKKKK");
        axios.get<any>(`${process.env.REACT_APP_NEW_API_ROOT}WBSEDCLERPPENSIONERFETCHDETAILSWS/FetchDetailsByPPONum`, {
            params: {
                ppoNum: {
                    ppoNum: store.auth.user?.id
                    // ppoNum: "80000006"
                }
            },
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(
                ({ data: resp }) => {
                    console.log(resp, "resp", resp && resp?.ppoNo);
                    if (resp && resp?.alreadyExist == "Y") {
                        setUser(resp);
                        setAlreadySubmittedForm({
                            url: `${process.env.REACT_APP_NEW_API_ROOT}irj/go/km/docs${resp.pdfURL}?time=${new Date().getTime()}`,
                        });
                        setAlreadySubmittedFormName('ApplicationFormForFamilyPensionersIdentityCard.pdf');
                    }
                    else if (resp && resp?.ppoNo) {
                        setUserMaritalStat(resp?.maritialStat);
                        resp.maritialStat = (resp?.maritialStat == 'NA' || resp?.maritialStat == 'NA') ? getMaritalStatusForDropdown(resp?.maritialStat ?? '') : getMaritalStatus(resp?.maritialStat ?? '');
                        resp.sex = getSex(resp?.sex ?? '');
                        resp.relationWith = getRelationWith(resp?.relationWith ?? '');
                        resp.panNum = (resp?.panNum == 'NA' || resp?.panNum == '') ? '' : resp?.panNum;
                        resp.aadharNum = (resp?.aadharNum == 'NA' || resp?.aadharNum == '') ? '' : resp?.aadharNum;
                        resp.dateOfBirth = resp.dateOfBirth ? resp.dateOfBirth == '0000-00-00' ? 'NA' : `${moment(resp.dateOfBirth).format('DD/MM/YYYY')}` : '';
                        resp.dateOfCommencement = resp.dateOfCommencement ? resp.dateOfCommencement == '0000-00-00' ? 'NA' : `${moment(resp.dateOfCommencement).format('DD/MM/YYYY')}` : '';
                        resp.dateOfSuperAnnuation = resp.dateOfSuperAnnuation ? resp.dateOfSuperAnnuation == '0000-00-00' ? 'NA' : `${moment(resp.dateOfSuperAnnuation).format('DD/MM/YYYY')}` : '';
                        setUser(resp);
                    }
                    else {
                        console.log("noooooooooooooooooo");

                        enqueueSnackbar("Something went wrong", { variant: 'error' });
                        setUser({
                            nameOfPensioner: "",
                            ppoNo: "",
                            guardianName: "",
                            maritialStat: "U",
                            relationWith: "",
                            address: "",
                            sex: "",
                            contactNo: "",
                            dateOfBirth: "",
                            dateOfCommencement: "",
                            panNum: "",
                            aadharNum: ""
                        })
                    }
                }
            )
            .catch((e) => {
                console.log(e, "error");
                setUser({
                    nameOfPensioner: "",
                    ppoNo: "",
                    guardianName: "",
                    maritialStat: "U",
                    relationWith: "",
                    address: "",
                    sex: "",
                    contactNo: "",
                    dateOfBirth: "",
                    dateOfCommencement: "",
                    panNum: "",
                    aadharNum: ""
                })
                // setLifeCerts({ loading: false, error: "Network Error", certs: [] });
            })
    }

    const toBase64 = (file: any) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            var img = new Image();
            img.src = window.URL.createObjectURL(file)
            img.onload = () => {
                console.log(img.naturalWidth, img.naturalHeight, "******");

                if (img.naturalWidth > 300 && img.naturalHeight > 300) {
                    // alert("Maximum acceptable dimensions are 300 x 300 pixels");
                    enqueueSnackbar("Maximum acceptable dimensions are 300 x 300 pixels", { variant: 'error' });
                    setProfilePicture('');
                    setProfilePictureImageType('');
                    setProfilePictureBase64('');
                    return;
                }
                return true;
            }

            return resolve(reader.result)
        };
        reader.onerror = error => reject(error);
    });

    const toSignatureBase64 = (file: any) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            var img = new Image();
            img.src = window.URL.createObjectURL(file)
            img.onload = () => {
                console.log(img.naturalWidth, img.naturalHeight, "******");

                if (img.naturalWidth > 300 && img.naturalHeight > 100) {
                    // alert("Maximum acceptable dimensions are 300 x 300 pixels");
                    enqueueSnackbar("Maximum acceptable dimensions are 300 x 100 pixels", { variant: 'error' });
                    setSignPicture('');
                    setSignPictureImageType('');
                    setSignPictureBase64('');
                    return;
                }
                return true;
            }

            return resolve(reader.result)
        };
        reader.onerror = error => reject(error);
    });


    return (
        <AppShell>
            <Grid container
                spacing={3}
                direction="column"
                justify="space-around"
                alignItems="stretch">
                <Formik
                    enableReinitialize
                    initialValues={{
                        year: getFiscalYear(new Date().getFullYear()),
                        part: "A",
                        file: alreadySubmittedForm,
                        fileName: alreadySubmittedFormName,

                        nameOfPensioner: user.nameOfPensioner,
                        ppoNo: user.ppoNo,
                        guardianName: user.guardianName,
                        maritialStat: user.maritialStat,
                        maritalStatusOthers: "",
                        relationWith: user.relationWith,
                        address: user.address,
                        sex: user.sex,
                        contactNo: user.contactNo,
                        dateOfBirth: `${user.dateOfBirth}`,
                        dateOfCommencement: `${user.dateOfCommencement}`,
                        panNum: user.panNum,
                        aadharNum: user.aadharNum,

                        spouseName: user.spouseName,
                        postAtRetirement: user.postAtRetirement,
                        dateOfSuperAnnuation: user.dateOfSuperAnnuation
                    }}
                    validate={(values) => {
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue, setFieldTouched, setFieldError }) => {
                        console.log(values.aadharNum, /^[2-9]{1}[0-9]{3}\s[0-9]{4}\s[0-9]{4}$/.test(values.aadharNum));

                        if (!profilePicture) {
                            enqueueSnackbar("Please upload a passport size photo", { variant: 'error' });
                        }
                        if (!signPicture) {
                            enqueueSnackbar("Please upload a signature photo", { variant: 'error' });
                        }
                        else if (!values.ppoNo) {
                            enqueueSnackbar("PPO Number not Entered", { variant: 'error' });
                        }
                        else if (!values.maritialStat || values.maritialStat == 'NA') {
                            enqueueSnackbar("Please select maritial status", { variant: 'error' });
                        }
                        else if (!values.panNum || values.panNum == 'NA') {
                            enqueueSnackbar("PAN Number not Entered", { variant: 'error' });
                        }
                        else if (values.panNum && /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(values.panNum) == false) {
                            enqueueSnackbar("PAN Number is Invalid", { variant: 'error' });
                        }
                        else if (!values.aadharNum || values.aadharNum == 'NA') {
                            enqueueSnackbar("Aadhar Number not Entered", { variant: 'error' });
                        }
                        else if (values.aadharNum && /^([0-9]{4}[0-9]{4}[0-9]{4}$)|([0-9]{4}\s[0-9]{4}\s[0-9]{4}$)|([0-9]{4}-[0-9]{4}-[0-9]{4}$)/.test(values.aadharNum) == false) {
                            enqueueSnackbar("Aadhar Number is Invalid", { variant: 'error' });
                        }
                        else {
                            setSubmitting(true)

                            console.log("SUBMIT+++++++++");


                            let inputs = {
                                "nameOfPensioner": user.nameOfPensioner,
                                "ppoNum": user.ppoNo,
                                "guardianName": user.guardianName,
                                "maritialStat": (userMaritalStat == 'NA' || userMaritalStat == '') ? getMaritalStatusToUpdate(values.maritialStat) : userMaritalStat,
                                "relationWith": user.relationWith,
                                "address": user.address,
                                "sex": user.sex,
                                "contactNo": user.contactNo,
                                "dateOfBirth": (user.dateOfBirth && user.dateOfBirth == 'NA') ? "00/00/0000" : user.dateOfBirth,
                                "dateOfCommencement": (user.dateOfCommencement && user.dateOfCommencement == 'NA') ? "00/00/0000" : user.dateOfCommencement,
                                "panNum": values.panNum,
                                "aadharNum": values.aadharNum,
                                "imageExtension": profilePictureImageType,
                                "imageByteArray": profilePictureBase64,

                                "spouseName": user?.spouseName ?? "NA",
                                "postAtRetirement": user?.postAtRetirement ?? "NA",
                                "dateOfSuperAnnuation": (user.dateOfSuperAnnuation && user.dateOfSuperAnnuation == 'NA') ? "00/00/0000" : user.dateOfSuperAnnuation,

                                "signatureExtension": signPictureImageType,
                                "signatureByteArray": signPictureBase64
                            }

                            console.log(JSON.stringify(inputs));


                            fetch(`${process.env.REACT_APP_NEW_API_ROOT}WBSEDCLERPPENSIONERDETAILSUPLOADWS/UploadPensionerDetails`, { body: JSON.stringify(inputs), method: 'post' })
                                .then((response) => response.json())
                                .then((resp) => {
                                    console.log(resp);
                                    setFieldValue('fileName', `ApplicationFormForFamilyPensionersIdentityCard.pdf`)
                                    setFieldValue('file', {
                                        url: `${process.env.REACT_APP_NEW_API_ROOT}irj/go/km/docs${resp.pdfUrl}?time=${new Date().getTime()}`,
                                    })
                                })
                                .catch((error) => {
                                    console.error(error);
                                });
                        }
                    }}
                >
                    {
                        ({ values, isSubmitting, isValid, setFieldValue, setValues, handleChange, setSubmitting }: FormikProps<FormikForm>) => {
                            return (
                                <Form>
                                    <Grid
                                        item
                                        container
                                        spacing={3}
                                        direction="column"
                                        justify="space-around"
                                        alignItems="stretch"
                                    >
                                        {
                                            !values.file && !values.fileName &&
                                            <Grid item>
                                                <Card className={classes.controlPaper}>
                                                    <CardContent>
                                                        <Grid container spacing={3} direction="column" justify="space-around"
                                                            alignItems="stretch">
                                                            <Grid item>
                                                                <Breadcrumbs>
                                                                    <Link to="/" className={classes.link}>
                                                                        <Typography gutterBottom variant="h5" component="h2">
                                                                            <HomeIcon className={classes.icon} />Home</Typography>
                                                                    </Link>
                                                                    <Typography gutterBottom variant="h5" component="h2">Application Form for Pensioner's Identity Card (পেনশনভোগীর পরিচয়পত্রের জন্য আবেদনপত্র)</Typography>
                                                                </Breadcrumbs>
                                                            </Grid>

                                                            <Grid item>
                                                                <Button
                                                                    variant="contained"
                                                                    component="label"
                                                                    size="large"
                                                                    disabled={isSubmitting}
                                                                >
                                                                    Upload Passport Size Photo
                                                                    <input
                                                                        type="file"
                                                                        hidden
                                                                        onChange={handleProfilePicChange}
                                                                        onClick={(event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
                                                                            const element = event.target as HTMLInputElement
                                                                            element.value = ''
                                                                        }}
                                                                        name="profilePicture"
                                                                        accept="image/png, image/jpeg, image/jpg"
                                                                    />
                                                                </Button>
                                                            </Grid>

                                                            <Grid item>
                                                                <FormControl variant="filled" fullWidth disabled={true}>
                                                                    {/* <IconButton color="inherit" onClick={(event) => {}}> */}
                                                                    <Avatar
                                                                        src={profilePicture}
                                                                        style={{
                                                                            margin: "10px",
                                                                            width: "120px",
                                                                            height: "120px",
                                                                            // alignSelf: 'flex-end'
                                                                        }}
                                                                    />
                                                                    {/* </IconButton> */}
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item>
                                                                <Alert severity={'info'}>
                                                                    <AlertTitle>
                                                                        Only .jpg, .jpeg, .png are accepted.
                                                                    </AlertTitle>
                                                                </Alert>
                                                            </Grid>
                                                            <Grid item>
                                                                <Alert severity={'info'}>
                                                                    <AlertTitle>
                                                                        Maximum acceptable dimensions are 300 x 300 pixels
                                                                    </AlertTitle>
                                                                </Alert>
                                                            </Grid>
                                                            <Grid item>
                                                                <Alert severity={'info'}>
                                                                    <AlertTitle>
                                                                        The image must be less than or equal to 240 kB (kilobytes)
                                                                    </AlertTitle>
                                                                </Alert>
                                                            </Grid>

                                                            <Grid item>
                                                                <Button
                                                                    variant="contained"
                                                                    component="label"
                                                                    size="large"
                                                                    disabled={isSubmitting}
                                                                >
                                                                    Upload Signature Photo
                                                                    <input
                                                                        type="file"
                                                                        hidden
                                                                        onChange={handleSignPicChange}
                                                                        onClick={(event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
                                                                            const element = event.target as HTMLInputElement
                                                                            element.value = ''
                                                                        }}
                                                                        name="signPicture"
                                                                        accept="image/png, image/jpeg, image/jpg"
                                                                    />
                                                                </Button>
                                                            </Grid>

                                                            <Grid item>
                                                                <FormControl variant="filled" fullWidth disabled={true}>
                                                                    <Card className={classes.signature}>
                                                                        <CardActionArea>
                                                                            <CardMedia
                                                                                image={signPicture ? signPicture : 'assets/img/sign1.png'}
                                                                                title=""
                                                                                style={{
                                                                                    height: 100,
                                                                                    width: 300,
                                                                                    backgroundSize: "contain",
                                                                                    borderWidth: 1,
                                                                                    borderRadius: 5,
                                                                                    borderColor: "#000"
                                                                                }}
                                                                            />
                                                                        </CardActionArea>
                                                                    </Card>
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item>
                                                                <Alert severity={'info'}>
                                                                    <AlertTitle>
                                                                        Only .jpg, .jpeg, .png are accepted.
                                                                    </AlertTitle>
                                                                </Alert>
                                                            </Grid>
                                                            <Grid item>
                                                                <Alert severity={'info'}>
                                                                    <AlertTitle>
                                                                        Maximum acceptable dimensions are 300 x 100 pixels
                                                                    </AlertTitle>
                                                                </Alert>
                                                            </Grid>
                                                            <Grid item>
                                                                <Alert severity={'info'}>
                                                                    <AlertTitle>
                                                                        The image must be less than or equal to 100 kB (kilobytes)
                                                                    </AlertTitle>
                                                                </Alert>
                                                            </Grid>

                                                            <Grid item>
                                                                <FormControl variant="filled" fullWidth disabled={true}>
                                                                    <AppInput
                                                                        inputProps={{ maxLength: 17 }}
                                                                        fullWidth={true}
                                                                        label={values.ppoNo.startsWith("800") ? "Name of pensioner" : "Name of Family pensioner"}
                                                                        name="nameOfPensioner"
                                                                        type="text"
                                                                        disabled={true}
                                                                    />
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item>
                                                                <FormControl variant="filled" fullWidth disabled={true}>
                                                                    <AppInput
                                                                        inputProps={{ maxLength: 17 }}
                                                                        fullWidth={true}
                                                                        label={values.ppoNo.startsWith("800") ? "PPO Number (For existing pensioner)" : "FPPO Number (For existing Family pensioner)"}
                                                                        name="ppoNo"
                                                                        type="text"
                                                                        disabled={true}
                                                                    />
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item>
                                                                <FormControl variant="filled" fullWidth disabled={true}>
                                                                    <AppInput
                                                                        inputProps={{ maxLength: 17 }}
                                                                        fullWidth={true}
                                                                        label={values.ppoNo.startsWith("800") ? "Father's/Husband's Name" : "Father's/Mother's/Husband's Name"}
                                                                        name="guardianName"
                                                                        type="text"
                                                                        disabled={true}
                                                                    />
                                                                </FormControl>
                                                            </Grid>

                                                            {user.maritialStat == 'NA' ?
                                                                <Grid item>
                                                                    <FormControl variant="filled" fullWidth disabled={user.maritialStat == 'NA' ? false : true}>
                                                                        <InputLabel id="demo-simple-select-filled-label">Marital Status</InputLabel>
                                                                        <Select
                                                                            labelId="demo-simple-select-filled-label"
                                                                            id="demo-simple-select-filled"
                                                                            name="maritialStat"
                                                                            className={classes.relation}
                                                                            value={values.maritialStat}
                                                                            onChange={handleChange}
                                                                        >
                                                                            <MenuItem value={"NA"}>Select Marital Status</MenuItem>
                                                                            <MenuItem value={"U"}>Unmarried</MenuItem>
                                                                            <MenuItem value={"W"}>Widow</MenuItem>
                                                                            <MenuItem value={"R"}>Widower</MenuItem>
                                                                            <MenuItem value={"D"}>Divorcee</MenuItem>
                                                                            <MenuItem value={"O"}>Others</MenuItem>
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid>
                                                                :
                                                                <Grid item>
                                                                    <FormControl variant="filled" fullWidth disabled={true}>
                                                                        <AppInput
                                                                            inputProps={{ maxLength: 17 }}
                                                                            fullWidth={true}
                                                                            label="Marital Status"
                                                                            name="maritialStat"
                                                                            type="text"
                                                                            disabled={true}
                                                                        />
                                                                    </FormControl>
                                                                </Grid>
                                                            }
                                                            {values.spouseName != undefined && values.spouseName != null && values.ppoNo.startsWith("800") &&
                                                                <Grid item>
                                                                    <FormControl variant="filled" fullWidth disabled={true}>
                                                                        <AppInput
                                                                            inputProps={{ maxLength: 17 }}
                                                                            fullWidth={true}
                                                                            label="Spouse Name"
                                                                            name="spouseName"
                                                                            type="text"
                                                                            disabled={true}
                                                                        />
                                                                    </FormControl>
                                                                </Grid>
                                                            }

                                                            {
                                                                user && user.relationWith && !values.ppoNo.startsWith("800") &&
                                                                <Grid item>
                                                                    <FormControl variant="filled" fullWidth disabled={true}>
                                                                        <AppInput
                                                                            inputProps={{ maxLength: 17 }}
                                                                            fullWidth={true}
                                                                            label="Relationship with pensioner"
                                                                            name="relationWith"
                                                                            type="text"
                                                                            disabled={true}
                                                                        />
                                                                    </FormControl>
                                                                </Grid>
                                                            }

                                                            <Grid item>
                                                                <FormControl variant="filled" fullWidth disabled={true}>
                                                                    <AppInput
                                                                        inputProps={{ maxLength: 17 }}
                                                                        fullWidth={true}
                                                                        label="Residential Address"
                                                                        name="address"
                                                                        type="text"
                                                                        multiline
                                                                        rowsMax={5}
                                                                        disabled={true}
                                                                    />
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item>
                                                                <FormControl variant="filled" fullWidth disabled={true}>
                                                                    <AppInput
                                                                        inputProps={{ maxLength: 17 }}
                                                                        fullWidth={true}
                                                                        label="Sex"
                                                                        name="sex"
                                                                        type="text"
                                                                        disabled={true}
                                                                    />
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item>
                                                                <FormControl variant="filled" fullWidth disabled={true}>
                                                                    <AppInput
                                                                        inputProps={{ maxLength: 17 }}
                                                                        fullWidth={true}
                                                                        label="Mobile no./ Telephone no."
                                                                        name="contactNo"
                                                                        type="text"
                                                                        disabled={true}
                                                                    />
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item>
                                                                <FormControl variant="filled" fullWidth disabled={true}>
                                                                    <AppInput
                                                                        inputProps={{ maxLength: 17 }}
                                                                        fullWidth={true}
                                                                        label="Date of Birth"
                                                                        name="dateOfBirth"
                                                                        type="text"
                                                                        disabled={true}
                                                                    />
                                                                </FormControl>
                                                                {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                <KeyboardDatePicker
                                                                    fullWidth={true}
                                                                    inputVariant="filled"
                                                                    label="Date of Birth"
                                                                    format="dd/MM/yyyy"
                                                                    value={values.dateOfBirth}
                                                                    onChange={value => setFieldValue("dateOfBirth", value)}
                                                                    disabled={isSubmitting}
                                                                />
                                                            </MuiPickersUtilsProvider> */}
                                                            </Grid>

                                                            {!values.ppoNo.startsWith("800") &&
                                                                <Grid item>
                                                                    <FormControl variant="filled" fullWidth disabled={true}>
                                                                        <AppInput
                                                                            inputProps={{ maxLength: 17 }}
                                                                            fullWidth={true}
                                                                            label={"Date of Commencement of family Pension"}
                                                                            name="dateOfCommencement"
                                                                            type="text"
                                                                            disabled={true}
                                                                        />
                                                                    </FormControl>
                                                                    {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                <KeyboardDatePicker
                                                                    fullWidth={true}
                                                                    inputVariant="filled"
                                                                    label="Date of Commencement"
                                                                    format="dd/MM/yyyy"
                                                                    className={classes.datePicker}
                                                                    value={values.dateOfCommencement}
                                                                    onChange={value => setFieldValue("dateOfCommencement", value)}
                                                                    disabled={isSubmitting}
                                                                />
                                                            </MuiPickersUtilsProvider> */}
                                                                </Grid>
                                                            }

                                                            {values.ppoNo.startsWith("800") &&
                                                                <Grid item>
                                                                    <FormControl variant="filled" fullWidth disabled={true}>
                                                                        <AppInput
                                                                            inputProps={{ maxLength: 17 }}
                                                                            fullWidth={true}
                                                                            label="Date of Superannuation"
                                                                            name="dateOfSuperAnnuation"
                                                                            type="text"
                                                                            disabled={true}
                                                                        />
                                                                    </FormControl>
                                                                </Grid>
                                                            }
                                                            {values.ppoNo.startsWith("800") &&
                                                                <Grid item>
                                                                    <FormControl variant="filled" fullWidth disabled={true}>
                                                                        <AppInput
                                                                            inputProps={{ maxLength: 17 }}
                                                                            fullWidth={true}
                                                                            label="Post held on Retirement"
                                                                            name="postAtRetirement"
                                                                            type="text"
                                                                            disabled={true}
                                                                        />
                                                                    </FormControl>
                                                                </Grid>
                                                            }

                                                            <Grid item>
                                                                <FormControl variant="filled" fullWidth disabled={isSubmitting ? true : (user.panNum != '' && user.panNum != 'NA') ? true : false}>
                                                                    <AppInput
                                                                        inputProps={{ maxLength: 10 }}
                                                                        fullWidth={true}
                                                                        label="PAN Number"
                                                                        name="panNum"
                                                                        type="text"
                                                                        maxLength={12}
                                                                        disabled={isSubmitting ? true : (user.panNum != '' && user.panNum != 'NA') ? true : false}
                                                                    />
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item>
                                                                <FormControl variant="filled" fullWidth disabled={isSubmitting ? true : (user.aadharNum != '' && user.aadharNum != 'NA') ? true : false}>
                                                                    <AppInput
                                                                        inputProps={{ maxLength: 12 }}
                                                                        fullWidth={true}
                                                                        label="AADHAAR Number"
                                                                        name="aadharNum"
                                                                        type="text"
                                                                        disabled={isSubmitting ? true : (user.aadharNum != '' && user.aadharNum != 'NA') ? true : false}
                                                                    />
                                                                </FormControl>
                                                            </Grid>

                                                            {/* <Grid item>
                                                            <Button
                                                                variant="contained"
                                                                component="label"
                                                                size="large"
                                                                disabled={isSubmitting}
                                                            >
                                                                Upload Signature
                                                                <input
                                                                    type="file"
                                                                    hidden
                                                                />
                                                            </Button>
                                                        </Grid> */}

                                                        </Grid>
                                                    </CardContent>
                                                    <CardActions>
                                                        {/* <Button type="reset" size="large" disabled={isSubmitting}>
                                                        Reset
                                                    </Button> */}
                                                        <LoadingButton type="submit" size="large" color="primary" variant="contained" loading={isSubmitting}>
                                                            Submit (জমা দিন)
                                                        </LoadingButton>

                                                        <Link to="/" className={classes.link}>
                                                            <Button variant='contained' color='primary' size="large">
                                                                Back (পিছনে)
                                                            </Button>
                                                        </Link>

                                                    </CardActions>
                                                </Card>
                                            </Grid>
                                        }
                                        {
                                            !!values.file && !!values.fileName &&
                                            < Grid item>
                                                <Card>
                                                    <CardContent>
                                                        <PdfViewer
                                                            downloadFileName={values.fileName}
                                                            file={values.file}
                                                            onDocumentLoadSuccess={() => { setSubmitting(false) }}
                                                            onDocumentLoadError={() => { setSubmitting(false) }}
                                                            error={
                                                                <>
                                                                    <Typography
                                                                        variant="h6"
                                                                        component="h6"
                                                                        style={{ textAlign: "center" }}
                                                                        color="secondary"
                                                                    >Unable to load PDF (পিডিএফ লোড করতে অক্ষম)</Typography>
                                                                </>
                                                            }
                                                        />
                                                    </CardContent>
                                                </Card>

                                                <Box marginTop={5} />
                                                <Grid item>
                                                    <Button variant='contained' color='primary' type="button" size="large" onClick={() => { history.push('/upload-attested-appl-form') }}>
                                                        Upload Attested Application Form PDF
                                                    </Button>
                                                </Grid>
                                                <Box marginTop={3} />
                                            </Grid>
                                        }
                                    </Grid>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Grid>
        </AppShell >
    )
}